<template>
  <!-- 公司详情 -->
  <div class="companyInfoWrap">
      <div class="wrapDiv">     
        <!-- 头部图片 -->
        <div class="top">        
          <div class="img"><img src="../images/companybg.png" alt=""></div>
          <span :class="company.isFollow == 0 ?'btn' :'btn isFollow' " @click="clickFollow">{{company.isFollow == 0 ? '关注' : '已关注'}}</span>
        </div>
        <div class="data">
          <div class="name clearfix">
            <div class="img">
              <img :src="company.companyLogo?company.companyLogo:require('../images/default.jpg')" alt="">
            </div>
            <div class="d1">
              <p class="p1">{{company.companyName}}</p>
              <p class="p2">{{company.followTotal}} 人关注</p>
            </div>          
          </div>
          <div class="phone">
            电话：<span class="sp1">{{company.companyMobile}}</span> <a @click="callFn" href="javascript:;">拨打</a>
          </div>
          <div class="dress">
            地址：<span class="sp1"><img src="" alt="">{{company.companyAddress}}</span>
          </div>
        </div>
        <div class="line"></div>
        <!-- 关于公司 -->
        <div class="aboutCompany">
          <div class="title">
            <span class="s1">关于公司</span>
            <span v-show="company.companyIntroduce.length > 100" class="s2" @click="showMore"><span :class="isMore ? 'arrow down' :'arrow up' "></span>{{isMore?'收起':'展开'}}</span>
          </div>
          <div :class=" isMore ? 'con heightAuto':'con heightAuto'" v-html="isMore?company.companyIntroduce:Substring(company.companyIntroduce)"></div>
        </div>
        <div class="line"></div>
        <!-- 最新需求 -->
        <!-- <div class="newDemand">
          <div class="title">
            <span class="s1">最新需求</span>
            <span class="s2" @click="moreDemand(company.companyId)">查看更多</span>
          </div>
          <ul class="conUl">
            <li v-for="item in demand">
              <p class="p1">{{item.demandTitle}}</p>
              <div class="d1 clearfix">
                <span class="span">{{item.demandType}}</span>
                <span class="time">{{item.createTime}}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="line"></div> -->
        <!-- 最新职位 -->
        <div class="newRecruit">
          <div class="title">
            <span class="s1">最新职位</span>
            <span class="s2" @click="moreRecruit(company.companyId)">查看更多</span>
          </div>
          <ul class="conUl">
            <li v-for="item in advertiseFor" @click="recruitInfo(item.advertiseId)">
              <p class="p1">
                {{item.advertisePosition}}
                <span>{{item.salary}}</span>
              </p>
              <p class="p2">
                <span class="s1"><img src="../images/wz.png" alt="">{{item.workingPlace}}</span>
                <span class="time">{{item.createTime}}</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 投递简历 -->
      <div class="send">
        <div class="btn" @click="popupVisible=true">投递简历</div>
      </div>
      <mt-popup v-model="popupVisible">
        <div class="popupwrap">请投递简历至邮箱<span>{{company.companyMail}}</span></div>
      </mt-popup>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import '../js/flexible.debug.js'
import global from "../js/global.js"
export default {
  data () {
    return {
      isMore:false,//展开
      popupVisible:false,
      heightAuto:'heightAuto',
      company:{},//公司信息
      advertiseFor:[],//招聘信息
      demand:[],//需求信息
      token:""
    }
  },
  created(){
    this.init();
  },
  mounted(){
      window.getToken = this.getToken;
      if(global.getmobiletype()=="android"){
        this.token = control.getToken()
      }
      else{
        window.webkit.messageHandlers.getToken.postMessage({"mothedName":"getToken"});
      }
  },
  methods:{
    callFn(){
      if(global.getmobiletype()=="android"){
        control.callTelePhone(this.company.companyMobile)
      }
      else{  
        window.webkit.messageHandlers.callTelePhoneWithNum.postMessage({"number":this.company.companyMobile});             
      }
    },
    getToken(token){
      this.token = token;
    },
    init(){
      // this.$http.get("content/app/company/detailed/query?companyId="+"5a7ac1e34423ce0001be3033"+"&operateType=1"+"&accountId=75")
      this.$http.get("content/app/company/detailed/query?companyId="+this.$route.query.contentId+"&operateType=1"+"&accountId="+this.$route.query.accountId)
      .then((response) => {
        this.company = response.respData.company
        this.advertiseFor = response.respData.advertiseFor
        this.demand = response.respData.demand
      });
    },
    clickFollow(){//关注
      Indicator.open();
      // this.$http.post("content/company/follow?companyId="+this.company.companyId+"&accountId="+'32')
      this.$http.post("content/company/follow?companyId="+this.company.companyId+"&accountId="+this.$route.query.accountId,"",{headers:{"Authorization":"bearer "+this.token+""}})
				.then((response) => {
          Indicator.close();
          this.init();
			});
    },
    moreDemand(id){
      var companyId = {'companyId':id}
      if(global.getmobiletype()=="android"){
        control.toNativeRequirementList(id);
      }
      else{
        window.webkit.messageHandlers.openRequirementTypeVCWithCompanyId.postMessage(companyId);
      }
    },
    moreRecruit(id){
      var companyId = {'companyId':id}
      if(global.getmobiletype()=="android"){
        control.toNativeRecruitList(id);
      }
      else{
        window.webkit.messageHandlers.openRecruitTypeVCWithCompanyId.postMessage(companyId);
      }
    },
    showMore(){
      this.isMore = !this.isMore;
    },
    Substring(value){
      return value.length > 100 ? value.substring(0,100)+'...' : value
    },
    recruitInfo(id){//跳转职位详情
      if(global.getmobiletype()=="android"){
        control.goNewPageWithShare(
          global.ipHeader+"/workInfo?contentId="+id+"&accountId="+this.$route.query.accountId,
          "职位详情",
          id,
          3
        )
      }
      else{
          window.webkit.messageHandlers.openNewWebViewWithNewNav.postMessage(
            {
              "url":global.ipHeader+"/workInfo?contentId="+id+"&accountId="+this.$route.query.accountId,
              "webTitle":"职位详情",
              'contentId':id,
              'dataType':'3',
              "mothedNameArr":["getToken","popViewToControllerWithLevelNum"]
            }
          );
      }
    }
  }
}
</script>

<style lang="less" scoped>
.wrapDiv{
  margin-bottom: 150px;
}
.companyInfoWrap{
  .top{
    position: relative;    
    width: 100%;
    height: 2.93rem;
    .img{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        max-width: 100%;
        max-height: 100%;
      }    
    }
    .btn{
      position: absolute;
      right: 30px;
      bottom: 40px;
      display: inline-block;
      font-size: 24px;
      padding: 10px 36px;
      background-image: linear-gradient(90deg, #EF4B4B 4%, #F7643C 100%);
      box-shadow: 0 6px 12px 0 rgba(239,75,75,0.30);
      border-radius: 200px;
      color:#fff;
    }
    .isFollow{
        background: #FFF1EF;
        color: #E27574;
        background-image: none;
        box-shadow: none;
    }
  }
  .data{
    background-color: #fff;
    .name{
      padding: 0 30px;
      margin-bottom: 8px;      
      min-height:20px;
      .img{
        float: left;
        width: 200px;
        height: 150px;
        margin-top: -32px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          max-width: 100%;
          max-height: 100%;
        }
      }
      .d1{
        float: left;
        margin-left: 28px;
        .p1{
          font-size: 30px;
          line-height: 42px;
          color:#333440;
          font-weight: bold;
          margin-bottom: 8px;
        } 
        .p2{
          font-size: 24px;
          line-height: 34px;
          color: #A4A4A4;
        }       
      }    
    }
    .phone{
      font-size: 26px;
      color: #5B5C66;
      padding: 21px 30px 28px 30px;
      border-bottom: 2px solid #EFEFEF;
      .sp1{
        font-size: 32px;
        color: #F3A117;
      }
      a{
        float:right;
        padding: 8px 32px;
        font-size: 22px;
        color:#EF4B4B;
        border: 2px solid #EF4B4B;
        border-radius: 41px;
      }
    }
    .dress{
      padding: 21px 30px 28px 30px;
      font-size: 26px;
      color: #5B5C66;
    }
  }
  .line{
    height: 20px;;
    background: #FBF6F6;
  }
  .aboutCompany{
    .title{
      height: 84px;
      line-height: 84px;
      padding: 0 30px;
      border: 1px solid #EFEFEF;
      .s1{
        font-size: 28px;
        color: #333440;
        font-weight: bold;
      }
      .s2{
        float: right;
        color: #EF4B4B;
        font-size: 22px;
        .arrow{
          display: inline-block;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          border-bottom-color: #EF4B4B;
          margin-right: 12px;
          border-width: 0 10px 10px;                    
        }
        .up{
          transform: rotate(-180deg);
          transition:all 0.5s;
        }
        .down{
          transform: rotate(0deg);        
          transition:all 0.5s;            
        }
      }
    }
    .con{
      width: 100%;
      font-size: 26px;
      line-height: 48px;
      color: #5B5C66;
      padding: 20px 30px 28px 30px;
      max-height: 288px;
      overflow: hidden;
    }
    .heightAuto{
      height: auto;
      max-height: none;
      overflow: auto; 
    }
  }
  .newDemand{
    .title{
      height: 84px;
      line-height: 84px;
      padding: 0 30px;
      border: 1px solid #EFEFEF;
      .s1{
        font-size: 28px;
        color: #333440;
        font-weight: bold;
      }
      .s2{
        float: right;
        font-size: 22px;
        color: #A4A4A4;
      }
    }
    .conUl{
      li{
        border: 1px solid #EFEFEF;  
        padding: 28px 30px 16px  30px;    
        .p1{
          font-size: 30px;
          line-height: 42px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .d1{
          .span{
            float: left;
            padding: 8px 15px;
            color: #5B5C66;
            background: #F3F3F3;
            border-radius: 200px;
            margin: 0 16px 16px 0; 
          }
          .time{
            float: right;
            font-size: 20px;
            padding: 8px 15px;
            color: #A4A4A4;
          }
        }
      }
    }
  }
  .newRecruit{
    .title{
      height: 84px;
      line-height: 84px;
      padding: 0 30px;
      border: 1px solid #EFEFEF;
      .s1{
        font-size: 28px;
        color: #333440;
        font-weight: bold;
      }
      .s2{
        float: right;
        font-size: 22px;
        color: #A4A4A4;
      }
    }
    .conUl{
      li{
        border: 1px solid #EFEFEF;  
        padding: 28px 30px 16px  30px;   
        .p1{
          font-size: 30px;
          line-height: 42px;
          font-weight: bold;
          margin-bottom: 12px;
          span{
            float: right;
            color: #EF4B4B;
          }
        }
        .p2{
          .s1{
            img{
              width: 20px;
              height: 24px;
              margin-right: 8px;
              vertical-align: middle;
            }
            font-size: 24px;
            color: #A4A4A4;
            line-height: 34px;
          }
          .time{
            float: right;
            font-size: 20px;
            color: #A4A4A4;
          }
        }
      }
    }
  }
  .send{
    position: fixed;
    width: 100%;
    height: 120px;
    left: 0;
    bottom: 0;
    background: #FFFFFF;
    box-shadow: 0 -8px 8px 0 rgba(0,0,0,0.04);
    padding: 20px 30px;
    .btn{
      width: 100%;
      height: 80px;
      line-height: 80px;
      background-image: linear-gradient(-90deg, #EF4B4B 0%, #F7643C 100%);
      box-shadow: 4px 8px 20px 0 rgba(239,75,75,0.27);
      border-radius: 8px;
      color:#fff;
      text-align: center;
    }
  }
  .popupwrap{
    font-size: 24px;
    color: #5B5C66;
    text-align: center;
    padding:30px;
    span{
        margin-top:20px;
        display: inline-block;
        color: #3da8f5;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/companyInfo.vue